import { SupportedRegions } from "@nova/constants"
import { z } from "zod"
import { ingestPayloadSchema } from "./payload"

const s3IngestEventSchema = z.object({
    source: z.literal("s3"),
    size: z.number(),
    userId: z.string(),
    s3Key: z.string(),
    payload: ingestPayloadSchema,
    region: z.enum(SupportedRegions),
    filename: z.string(),
    requestId: z.string(),
})

export type S3IngestEvent = z.infer<typeof s3IngestEventSchema>

export const ingestEventSchema = z.discriminatedUnion("source", [s3IngestEventSchema])

export type IngestEvent = z.infer<typeof ingestEventSchema>
